// ChartContainer.tsx
import { Box, Text, Skeleton } from '@chakra-ui/react' // ❗ УБРАН IMPORT Card
import React from 'react'

type Props = {
  title?: string
  subtitle?: string
  h?: number | string
  isLoading?: boolean
  isEmpty?: boolean
  children: React.ReactNode
}

export default function ChartContainer({
  title,
  subtitle,
  h = 260,
  isLoading,
  isEmpty,
  children,
}: Props) {
  return (
    <Box bg="bg" borderWidth="none" overflow="hidden" p={0}>
      {(title || subtitle) && (
        <Box px={4} pt={4}>
          {title && (
            <Text textStyle="sm.fontNormal" color="fg.muted">
              {title}
            </Text>
          )}
          {subtitle && (
            <Text textStyle="micro" color="fg.muted">
              {subtitle}
            </Text>
          )}
        </Box>
      )}

      <Box px={0} pb={4}>
        {isLoading ? (
          <Skeleton w="100%" h={h} />
        ) : isEmpty ? (
          <Box h={h} display="flex" alignItems="center" justifyContent="center">
            <Text color="fg.muted">Keine Daten</Text>
          </Box>
        ) : (
          <Box w="100%" h={h} m={0} p={0}>
            {children}
          </Box>
        )}
      </Box>
    </Box>
  )
}
